document.addEventListener('DOMContentLoaded', function() {
  function ensureCartFooterVisibility(cart) {
    const cartDrawerFooter = document.querySelector('.scd__footer');
    if (cartDrawerFooter && cart && cart.item_count > 0) {
      cartDrawerFooter.classList.remove('hidden');
    } else if (cartDrawerFooter && cart && cart.item_count === 0) {
      cartDrawerFooter.classList.add('hidden');
    }
  }

  function updateCartCounts(count) {
    
    const cartCounts = document.querySelectorAll('.sf-cart-count');
    cartCounts.forEach(element => {
      element.textContent = count;
      element.setAttribute('data-count', count);
    });
  }

  async function refreshCartCounts() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart data');
      
      const cart = await response.json();
      updateCartCounts(cart.item_count);
      
      return cart;
    } catch (error) {
      console.error('Error refreshing cart counts:', error);
      return null;
    }
  }

  refreshCartCounts();

  if (window.location.pathname.includes('/cart')) {

    function handleCartQuantityChange() {
      setTimeout(refreshCartCounts, 300);
    }

    const qtyInputs = document.querySelectorAll('input[name="updates[]"]');
    const qtyIncButtons = document.querySelectorAll('.quantity__button--plus, [data-action="increase-quantity"], .js-qty__adjust--plus');
    const qtyDecButtons = document.querySelectorAll('.quantity__button--minus, [data-action="decrease-quantity"], .js-qty__adjust--minus');
    

    qtyInputs.forEach(input => {
      input.addEventListener('change', handleCartQuantityChange);
    });

    qtyIncButtons.forEach(button => {
      button.addEventListener('click', handleCartQuantityChange);
    });

    qtyDecButtons.forEach(button => {
      button.addEventListener('click', handleCartQuantityChange);
    });

    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function() {
        setTimeout(refreshCartCounts, 300);
      });
    }

    const cartItemContainer = document.querySelector('.cart__items, .cart-items, .cart__body');
    if (cartItemContainer) {
      const observer = new MutationObserver(handleCartQuantityChange);
      observer.observe(cartItemContainer, { childList: true, subtree: true, attributes: true });
    }
  }

  if (typeof MinimogEvents !== 'undefined') {
    MinimogEvents.subscribe('ON_CART_UPDATE', function(cart) {
      if (cart) {
        updateCartCounts(cart.item_count);
        
        const cartDrawerHeader = document.querySelector('.scd__header h3');
        if (cartDrawerHeader) {
          cartDrawerHeader.textContent = `MY CART (${cart.item_count})`;
        }
        
        ensureCartFooterVisibility(cart);
      } else {
        refreshCartCounts();
      }
    });
    
    MinimogEvents.subscribe('ON_ITEM_ADDED', function(item) {
      refreshCartCounts();
      
      const cartDrawerFooter = document.querySelector('.scd__footer');
      if (cartDrawerFooter) {
        cartDrawerFooter.classList.remove('hidden');
      }
    });
    
    MinimogEvents.subscribe('ON_OPEN_DRAWER_CART', function(cart) {
      if (cart) {
        updateCartCounts(cart.item_count);
        ensureCartFooterVisibility(cart);
      } else {
        refreshCartCounts();
      }
    });
  }

    if (typeof Shopify !== 'undefined') {
    if (typeof Shopify.onCartUpdate === 'function') {
      const originalOnCartUpdate = Shopify.onCartUpdate;
      Shopify.onCartUpdate = function(cart, open_drawer) {
        originalOnCartUpdate(cart, open_drawer);
        
        if (cart) {
          updateCartCounts(cart.item_count);
          
          const cartDrawerHeader = document.querySelector('.scd__header h3');
          if (cartDrawerHeader) {
            cartDrawerHeader.textContent = `MY CART (${cart.item_count})`;
          }
          
          ensureCartFooterVisibility(cart);
        }
      };
    }
    
    if (typeof Shopify.updateCartNote === 'function') {
      const originalUpdateCartNote = Shopify.updateCartNote;
      Shopify.updateCartNote = function() {
        originalUpdateCartNote.apply(this, arguments);
        setTimeout(refreshCartCounts, 300);
      };
    }
  }

  document.addEventListener('cart:refresh', function(event) {
    if (event.detail && event.detail.cart) {
      updateCartCounts(event.detail.cart.item_count);
      
      const cartDrawerHeader = document.querySelector('.scd__header h3');
      if (cartDrawerHeader) {
        cartDrawerHeader.textContent = `MY CART (${event.detail.cart.item_count})`;
      }
      
      ensureCartFooterVisibility(event.detail.cart);
    } else {
      refreshCartCounts();
    }
  });
  
  if (window.location.pathname.includes('/cart')) {
    setInterval(refreshCartCounts, 1000);
  }
}); 